export const result = {
  sucess: false,
  msg: 'Falha na operação...',
  data: []
}

